import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {isTeamNamespace} from '../../helpers/models/namespaceHelpers';
import {SettingsSidebarInfoBox} from '../common/settingsSidebarInfoBox';

/*
 * Props.
 */

interface SettingsInboxesSidebarProps {
  namespace: string;
  onCloseClick: Handler;
  onFooterClick: Handler;
}

/*
 * Component.
 */

export const SettingsInboxesSidebar: FC<SettingsInboxesSidebarProps> = (props) => {
  if (isTeamNamespace(props.namespace)) {
    return (
      <SettingsSidebarInfoBox
        title={<Trans id="settingsinboxes-infobox-team-title">Team inboxes</Trans>}
        body={
          <p>
            <Trans id="settingsinboxes-infobox-team-body">
              Team inboxes enable multiple people to work together and respond faster to messages. A team
              inbox can contain shared conversations from a single communication channel (like your support@
              email address) or multiple channels (like Twitter and SMS).
            </Trans>
          </p>
        }
        footer={<Trans id="settingstags-infobox-team-footer">Learn more</Trans>}
        onCloseClick={props.onCloseClick}
        onFooterClick={props.onFooterClick}
      />
    );
  }

  return (
    <SettingsSidebarInfoBox
      title={<Trans id="settingsinboxes-infobox-user-title">Individual inboxes</Trans>}
      body={
        <p>
          <Trans id="settingsinboxes-infobox-user-body">
            Connecting your individual email account to Front helps you consolidate all of your work into one
            place. Your individual inbox is private by default, but you can selectively share messages with
            your team and collaborate with them using comments, @mentions, draft sharing, message templates,
            and more.
          </Trans>
        </p>
      }
      footer={<Trans id="settingstags-infobox-private-footer">Learn more</Trans>}
      onCloseClick={props.onCloseClick}
      onFooterClick={props.onFooterClick}
    />
  );
};
